import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-curriculo-alert',
  templateUrl: './curriculo-alert.component.html',
  styleUrls: ['./curriculo-alert.component.scss']
})
export class CurriculoAlertComponent implements OnInit {

  empty: any;
  firstJob: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data
  ) {

    this.empty = data.empty;
    this.firstJob = data.first_job
  }

  ngOnInit(): void {
  }

}
